<template>
    <section>
        <div v-if="addEditCollectionDivision" class="">
            <div id="details" class="overlay waste_type_pop">
                <div class="overlay_inner">
                    <div class="row form-modal">
                        <vue-form :state="formstate">
                            <h4 class="text-center">{{ status }} Collection Division</h4>
                            <div class="col-sm-12" style="padding-top:15px">

                                <validate auto-label class="form-group required-field"
                                    :class="fieldClassName(formstate.addEditcollectionDivisions)">
                                    <label>Ward / Society / Mohalla</label>
                                    <input type="text" name="addEditcollectionDivisions" class="form-control" required
                                        v-model="addEditcollectionDivisions" placeholder="Ward / Society / Mohalla"
                                        maxlength="45" pattern="^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,45}[^\s]$" />
                                    <field-messages name="addEditcollectionDivisions" show="$touched || $submitted"
                                        class="form-control-feedback validation_msg">
                                        <div slot="required">
                                            Ward / Society / Mohalla is a required field
                                        </div>
                                        <div slot="pattern">
                                            Alphabets/Numbers/Special Characters are allowed.
                                        </div>
                                    </field-messages>
                                </validate>

                            </div>
                        </vue-form>
                        <div class="form-actions">
                            <button type="submit" @click="addCollection"
                                :disabled="!(formstate.$dirty && formstate.$valid)" v-if="mode === 'create'"
                                v-bind:class="'mr-2 btn gradientbt'">
                                Add
                            </button>
                            <button type="submit" @click="updateCollection"
                                :disabled="!(formstate.$dirty && formstate.$valid)" v-if="mode === 'edit'"
                                v-bind:class="'mr-2 btn gradientbt'">
                                Update
                            </button>
                            <button @click="onCloseCDD" v-bind:class="'mr-5  btn btn-default'">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="isMapActive" class="">
            <div class="location">
                <div id="details" class="overlay waste_type_pop">
                    <div class="overlay_inner">
                        <div class="row form-modal">
                            <div class="d-flex justify-right">
                                <button @click="onCloseMap" v-bind:class="'mr-5 btn btn-default close-button'">
                                    X
                                </button>
                            </div>
                            <div v-if="houseLocation" class="map-show">
                                <multiLocation />
                            </div>
                            <div v-if="!houseLocation">
                                No records Found
                            </div>
                            <div class="d-flex justify-right">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isKmlShow" class="">
            <div class="location">
                <div id="details" class="overlay waste_type_pop">
                    <div class="overlay_inner">
                        <div class="row form-modal">
                            <div class="d-flex justify-right">
                                <button @click="closeKmlMap" v-bind:class="'mr-5 btn btn-default close-button'">
                                    X
                                </button>
                            </div>
                            <div v-if="isKmlShow" class="map-show">
                                <kmlView></kmlView>
                            </div>
                            <div class="d-flex justify-right">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isUploadKmlPopUp" class="">
            <div class="location">
                <div id="details" class="overlay waste_type_pop">
                    <div class="overlay_inner">
                        <div class="rows form-modals modalbg">
                            <div class="d-flex justify-right">
                                <button @click="openUploadKmlPopup" v-bind:class="'mr-5 btn btn-default close-button'">
                                    X </button>
                            </div>
                            <div>
                                <label class="kmllabel">File</label>
                                <input type="file" accept=".kml" class="form-control kmlInput"
                                    v-on:change="onDocumentchanged">
                                <button class="form-control kmlButton" :disabled="isKmlUpdateButtonEnable"
                                    @click="uploadKmlFile">Upload</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loadingKlm" class="content content-centered">
            <pulse-loader></pulse-loader>
            <p>Please wait, KML File is Uploading</p>
        </div>
        <div v-if="!loadingKlm" class="collection_division_info collection_new_wrp">
            <div class="row area-name area-name-bg">
                <div class="area_inner_side">
                    <div class="area_inner">
                        <h4>Area Name</h4>
                        <div class="edit_side" style="display: flex;">
                            <p>{{ details.areaName }}</p>
                            <button class="fa fa-edit" role="button" v-on:click="editInfo(details)"></button>
                        </div>
                    </div>
                    <div class="area_inner">
                        <h4>City</h4>
                        <p>{{ details.cityId && details.cityId.cityName ? details.cityId.cityName : "" }}</p>
                    </div>
                    <!-- <div class="area_inner" v-if="details.areaLocation !== '--'">
                    <h4>Location</h4>
                    <p>{{ details.areaLocation }}</p>
                </div> -->
                    <!-- <div class="area_inner" v-if="details.transportName !== '--'">
                    <h4>Transfer Point</h4>
                    <p>{{ details.transportName }}</p>
                </div> -->
                    <!-- <div class="area_inner" v-if="details.plantName !== '--'">
                    <h4>Segrgation Point</h4>
                    <p>{{ details.plantName }}</p>
                </div> -->
                    <!-- <div class="area_inner" v-if="details.dumpYardName !== '--'">
                    <h4>Dump Yard</h4>
                    <p>{{ details.dumpYardName }}</p>
                </div> -->

                    <div class="area_inner right">
                        <button role="button" class="action_btn" v-on:click="houseLocationOnMap">View Houses</button>
                    </div>
                    <div v-if="!this.details.routeFileUri || isUploadButton" class="area_inner right">
                        <button role="button" class="action_btn" v-on:click="openUploadKmlPopup">Upload Route
                            File</button>
                    </div>
                    <div v-if="isButtonEnable" class="area_inner right">
                        <button role="button" class="action_btn" v-on:click="openRoutePopupMap">View Route</button>
                    </div>
                    <div v-if="isButtonEnable" class="area_inner right">
                        <button role="button" class="action_btn" @click="deleteLineModal()">Delete Route</button>
                    </div>
                </div>


            </div>

            <div class="area_inner_addnew_paddi">
                <div class="area-name area_inner_addnew">
                    <h4>
                        <span class="text-justify">Collection Divisions</span>
                        <div class="addcollecction_wrp">
                            <button class=" btn gradientbt" @click="addColletion">
                                Add Collection Division
                            </button>
                        </div>
                    </h4>
                </div>
                <div class="scroll-items">
                    <div class="details-card" style="background:#fff;">
                        <div class="collection_divisions_table">
                            <table>
                                <tr>
                                    <th>Ward / Society / Mohalla</th>
                                    <th>Line / Tower</th>
                                    <th>Houses / Flats</th>
                                    <th>Action</th>
                                </tr>
                                <tr v-for="item in detailss" :key="item.divisionId">
                                    <td>
                                        {{ item.divisionName }}
                                        <button class="fa fa-pencil" role="button"
                                            v-on:click="editCdaName(item.divisionId, item)"></button>
                                    </td>
                                    <td>{{ item.liness }}</td>
                                    <td>{{ item.housess }}</td>
                                    <td>
                                        <div class="view_flex">
                                            <button class="fa fa-home" role="button" v-on:click="viewHouse(item)">

                                            </button>

                                            <div class="">
                                                <button class="fa fa-edit" role="button"
                                                    v-on:click="ViewLineTower(item)"></button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div v-if="!showRecords" class="noRecords">No Records Found</div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import store from "../../../store";
import {
    eventBus,
    formService,
    wasteCollectionAreaService,
} from "../../../services";
import {
    ServerTable,
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";
import swal from "sweetalert2";
import multiLocation from "../gmapLocation/multiLocation";
import KmlView from "../gmapLocation/kmlView";

export default {
    name: "wasteCollectionAreaDetails",
    components: {
        multiLocation,
        KmlView,
    },
    data() {
        return {
            addEditcollectionDivisions: {},
            subCityAdmin: true,
            addEditCollectionDivision: false,
            updateCategoryDetails: false,
            showRecords: false,
            show: false,
            isMapActive: false,
            isKmlShow: false,
            routeFileUri: '',
            houseLocation: true,
            isUploadKmlPopUp: false,
            isKmlUpdateButtonEnable: true,
            isButtonEnable: false,
            isUploadButton: false,
            kmlDoc: null,
            input: "",
            status: "Add",
            loadingKlm: false,
            rows: [],
            items: [],
            details: {},
            detailss: [],
            formstate: {},
            wcaID: "",
            collectionDivisions: {
                lineTowerHouse: [{
                    name: "",
                    houses: [{
                        hnNo: "",
                    },],
                },],
            },
            collectionDivisionsData: {},
            // surveyor: [],
            mode: "create",
            line: {},
            wsmUpdate: {},
        };
    },
    mounted: function () {
        // this.getWasteCollectionDetails();
    },
    methods: {
        fieldClassName: formService.fieldClassName,

        onDocumentchanged(event) {
            const fileName = document.getElementById("fileName");
            if (event.target.files[0].size > 1024 * 1024 * 2) {
                this.$snotify.error("File Size max limit of 2 MB", "Error!");
                fileName.value = "";
                event.preventDefault();
                return;
            } else {
                this.isKmlUpdateButtonEnable = false;
                this.kmlDoc = event.target.files[0];
            }
            this.items.push(this.input);
            this.input = "";
        },

        deleteLineModal() {
            swal({
                title: `Are you sure you want to delete the route for ${this.details.areaName}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                customClass: "swal-modal2",
                width: "400px",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.uploadKmlFile()
                }

            });
        },
        uploadKmlFile() {

            const formData = new FormData();
            formData.append("file", this.kmlDoc);
            this.isUploadKmlPopUp = false;
            this.kmlDoc = null;
            if (formData.entries().next().value[1] == "null") {
                return wasteCollectionAreaService
                    .deleteKmlFile(this.details._id)
                    .then((response) => {
                        this.isButtonEnable = false;
                        this.isUploadButton = true;
                        this.loading = false;
                        this.flash = false;
                        this.show = false;
                        this.$snotify.success("File deleted!", "Success!");
                    }).catch((error) => {
                        this.loading = false;
                        this.$snotify.error(
                            `${error.data.message}`, "Error!"
                        );
                    });
            } else {
                this.loadingKlm = true
                return wasteCollectionAreaService
                    .addKmlFile(this.details._id, formData)
                    .then((response) => {
                        this.getWasteCollectionDetails();
                        this.isButtonEnable = true;
                        this.isUploadButton = false;
                        this.loadingKlm = false
                        this.loading = false;
                        this.flash = false;
                        this.show = false;
                        this.$snotify.success("File Uploded!", "Success!");
                    });
            }
        },
        openUploadKmlPopup() {
            this.isUploadKmlPopUp = !this.isUploadKmlPopUp;
            this.isKmlUpdateButtonEnable = true;
        },
        openRoutePopupMap() {
            this.isKmlShow = true;
            eventBus.$off("routeFileUriWasteCollection");
            eventBus.$on("routeFileUriWasteCollection", () => {
                eventBus.$emit("routeFileUri", this.details.routeFileUri);
            });
        },
        closeKmlMap() {
            this.isKmlShow = false;
        },

        addMore() {
            this.collectionDivisions.lineTowerHouse.push({
                name: "",
                houses: [{
                    hnNo: "",
                },],
            });
        },
        remove(index) {
            this.collectionDivisions.lineTowerHouse.splice(index, 1);
        },
        addMoreHouses(lineTowerIndex) {
            this.collectionDivisions.lineTowerHouse[lineTowerIndex].houses.push({
                hnNo: "",
            });
        },
        removeHouse(lineTowerIndex, houseIndex) {
            this.collectionDivisions.lineTowerHouse[lineTowerIndex].houses.splice(
                lineTowerIndex,
                1
            );
        },
        addColletion() {
            this.addEditcollectionDivisions = '';
            this.addEditCollectionDivision = true;

            this.status = 'Add';
            this.mode = 'create'

        },
        addToItems() {
            if (!this.input) {
                return;
            }
            this.items.push(this.input);
            this.input = "";
        },
        getWasteCollectionDetails() {

            let wcaId;
            if (this.$route.params._id) {
                wcaId = this.$route.params._id;
            } else {
                wcaId = this.wcaID;
            }

            this.loading = true;
            return wasteCollectionAreaService
                .getwasteCollection(wcaId)
                .then((response) => {
                    this.$store.dispatch(
                        "setBreadcrumbTitle",
                        response.data.response.areaName
                    );
                    this.details = response.data.response;
                    this.details.routeFileUri ? this.isButtonEnable = true : this.isButtonDisable = false;
                    this.details['dumpYardName'] = this.details.dumpyardId ? this.details.dumpyardId.dumpYardName : '--';
                    this.details['transportName'] = this.details.transportId ? this.details.transportId.transportName : '--';
                    this.details['plantName'] = this.details.segregationId ? this.details.segregationId.plantName : '--';
                    this.details['areaLocation'] = this.details.areaLocation ? this.details.areaLocation : '--';
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(
                        "wasteCollectionDetails.getWasteCollection-error:",
                        error
                    );
                });
        },

        getcollectionDivisionDetails() {
            let wcaId;
            if (this.$route.params._id) {
                wcaId = this.$route.params._id;
            } else {
                wcaId = this.wcaID;
            }

            this.detailss = [];
            this.loading = true;
            return wasteCollectionAreaService
                .getCollectionDivisionList(wcaId)
                .then((response) => {
                    response.data.response.forEach((element) => {
                        let data = element;
                        let houseList = [];
                        data["liness"] = element.lineTowerData.length;
                        houseList = element.lineTowerData.map((el) => el.totalHouse);
                        data["housess"] = houseList.reduce(
                            (partialSum, a) => partialSum + a,
                            0
                        );
                        this.detailss.push(data);
                    });
                    this.loading = false;
                    this.showRecords = response.data.response.length > 0 ? true : false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("UserDetails.updateUser-error:", error);

                });
        },

        createCollectionDivisions() {
            this.loading = true;
            this.collectionData = {};
            this.collectionDivisionsData["caId"] = this.details._id;
            this.collectionDivisionsData["cdName"] = this.collectionDivisions.cdaName;
            this.collectionDivisionsData["cdaName"] = this.collectionDivisions.cdaName;
            this.collectionDivisionsData["lineTowerHouse"] = this.collectionDivisions.lineTowerHouse;
            this.collectionDivisionsData["userId"] = store.state.auth.user._id;
            return wasteCollectionAreaService
                .addcollectionDivision(this.collectionDivisionsData)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.show = false;
                    this.$snotify.success("collection division  added!", "Success!");
                    this.getcollectionDivisionDetails();
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message.includes("Duplicate")) {
                        var errorMessage = "This collection name name already exist";
                        this.$snotify.error(errorMessage, "Error!");
                    }
                });
        },

        ViewLineTower(data) {
            this.$router.push({
                name: "lineTowerList",
                params: {
                    _id: data.divisionId,
                    cdId: data.collectionAreaId,
                },
                props: data,
            });
        },

        viewHouse(data) {
            this.$router.push({
                name: "houseList",
                params: {
                    _id: data.divisionId,
                    cdId: data.collectionAreaId
                },
                props: data,
            });
        },

        editCollection(data) {

            this.$router.push({
                name: "collectionDivisionCreate",
                params: {
                    _id: data._id,
                    wcaId: this.details._id,
                },
                props: data,
            });
        },

        getCollectiondivisionById(id) {
            this.show = true;

            return wasteCollectionAreaService
                .getCollectionDivisionById(id)
                .then((response) => {
                    this.collectionId = response.data.response._id;
                    let data = response.data.response;
                    this.collectionDivisions["cdaName"] = data.cdaName;
                    this.collectionDivisions["lineTowerHouse"] = data.lineTowerHouse;
                });
        },

        updateCollectionDivisions() {
            this.loading = true;

            this.collectionData = {};
            this.collectionDivisionsData["caId"] = this.details._id;
            this.collectionDivisionsData["cdName"] = this.collectionDivisions.cdaName;
            this.collectionDivisionsData[
                "cdaName"
            ] = this.collectionDivisions.cdaName;
            this.collectionDivisionsData["lineTowerHouse"] = [];
            for (let i = 0; i < this.collectionDivisions.lineTowerHouse.length; i++) {
                this.line = {};
                this.line.name = this.collectionDivisions.lineTowerHouse[i]["name"];
                this.collectionDivisionsData["lineTowerHouse"][
                    "name"
                ] = this.collectionDivisions.lineTowerHouse[i]["name"];
                this.line["houses"] = [];
                for (
                    let j = 0; j < this.collectionDivisions.lineTowerHouse[i].houses.length; j++
                ) {
                    let house = {};
                    house.hnNo = this.collectionDivisions.lineTowerHouse[i]["houses"][j][
                        "hnNo"
                    ];
                    this.line["houses"].push(house);
                }
                this.collectionDivisionsData["lineTowerHouse"].push(this.line);
            }

            this.collectionDivisionsData["userId"] = store.state.auth.user._id;
            // this.collectionDivisionsData['cityId']= this.collectionDivisions.cityId
            this.collectionDivisionsData["_id"] = this.collectionId;
            return wasteCollectionAreaService
                .updatecollectionDivision(this.collectionDivisionsData)
                .then((response) => {
                    this.loading = false;
                    this.show = false;
                    this.flash = false;
                    // this.$ref.collectionForm.reset()
                    this.$snotify.success("collection division updated!", "Success!");
                    this.getcollectionDivisionDetails();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error, "Error!");
                    if (error.data.message.includes("Duplicate")) {
                        var errorMessage = "This wasteCollectionArea name already exist";
                        this.$snotify.error(errorMessage, "Error!");
                    }
                });
        },
        editInfo(data) {
            this.$router.push({
                name: "wasteCollectionAreaCreate",
                params: {
                    _id: data._id,
                },
                // props: this.details,
            });
        },
        onCloseCDD() {
            // this.collectionDivisions.cdaName = "";
            this.addEditcollectionDivisions = '';
            this.addEditCollectionDivision = false;
        },
        addCollection() {
            this.loading = true;
            this.collectionData = {};
            this.collectionDivisionsData["caId"] = this.details._id;
            this.collectionDivisionsData["cdName"] = this.addEditcollectionDivisions;
            this.collectionDivisionsData["cdaName"] = this.addEditcollectionDivisions;
            if (this.showLine) {
                this.collectionDivisionsData[
                    "lineTowerHouse"
                ] = this.collectionDivisions.lineTowerHouse;
            }
            this.collectionDivisionsData["userId"] = store.state.auth.user._id;
            return wasteCollectionAreaService
                .addcollectionDivision(this.collectionDivisionsData)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.show = false;

                    this.$snotify.success("collection division  added!", "Success!");
                    this.addEditCollectionDivision = false;
                    this.addEditcollectionDivisions = '';
                    this.getcollectionDivisionDetails();

                })
                .catch((error) => {
                    this.loading = false;
                    this.addEditcollectionDivisions = '';
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    }
                });

        },

        onClose() {
            this.addEditcollectionDivisions = "";
            this.addEditCollectionDivision = false;
        },
        editCdaName(id, item) {
            this.status = 'Update'
            this.mode = 'edit'
            this.rows["_id"] = id;
            this.rows["divisionName"] = item.divisionName;
            this.addEditcollectionDivisions = item.divisionName;
            this.addEditCollectionDivision = true;

        },
        updateCollection() {
            this.loading = true;
            let cdPayload = {};
            cdPayload["_id"] = this.rows._id;
            cdPayload["name"] = this.addEditcollectionDivisions;
            return wasteCollectionAreaService
                .updateCDName(cdPayload)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The collection division name has been updated successfully.`
                    );
                    this.addEditCollectionDivision = false;
                    this.getcollectionDivisionDetails();
                    this.addEditcollectionDivisions = "";
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error!");
                });
        },
        onCloseMap() {
            this.isMapActive = false;
            this.isKmlShow = false;
        },

        getAllHouses() {
            let housesInfo = [];
            return wasteCollectionAreaService
                .getAllHousesByWCId(this.$route.params._id)
                .then((response) => {
                    response.data.response.forEach((element) => {
                        if (element.geoLoc.length > 0) {
                            let house = element;
                            house['lat'] = element.geoLoc[1]
                            house['lng'] = element.geoLoc[0]
                            house['label'] = element.houseNo + "(" + (element.surveyStatus == "Active" ? "Completed" : "Pending") + ")"
                            housesInfo.push(house)
                        }
                    })
                    if (housesInfo.length > 0) {
                        this.houseLocation = true;
                        eventBus.$emit("housesLocation", housesInfo);
                    } else {
                        this.houseLocation = false;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error, "Error!");
                });
        },
        houseLocationOnMap() {
            this.isMapActive = true
            this.getAllHouses()
        },

    },
    mounted() {
        if (this.$store.state.auth.user.role.key === "subCityAdmin") {
            this.subCityAdmin = false
        }
    },
    created() {

        const promises = [];
        this.loading = true;
        // if (this.$route.params && this.$route.params._id || this.wcaID) {
        promises.push(this.getWasteCollectionDetails());
        promises.push(this.getcollectionDivisionDetails());

        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },

};
</script>

<style scoped>
.collection_division {
    padding: 15px;
}

.collection_division table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

.collection_division td,
.collection_division th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
}

.collection_division_inner {
    padding-top: 20px;
}

.overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.sidepop {
    position: fixed;
    width: 735px;
    z-index: 9999;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    right: 0;
    top: 0;
    height: 100%;
}

/* .toggle {
  position: relative;
  z-index: 999999;
} */
.collection_division_pop_wrp h2 {
    font-size: 22px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 20px;
}

.collection_input input {
    width: 100%;
    border: 2px solid #ddd;
    padding: 10px;
    border-radius: 0px;
}

.collection_input p {
    margin-bottom: 5px;
    font-weight: 600;
}

.collection_input input:focus {
    outline: 0;
    border: 2px solid #ddd;
}

.houses_boxs {
    padding-left: 15px;
    padding-right: 15px;
}

.houses_boxs input {
    margin-right: 15px;
    width: 85px;
    border: 2px solid #ddd;
    padding: 10px;
    border-radius: 0px;
    margin-bottom: 15px;
}

.houses_boxs input:focus {
    outline: 0;
    border: 2px solid #ddd;
}

.houses_boxs p {
    margin-bottom: 5px;
    font-weight: 600;
}

.houses_boxs_wrp {
    margin-top: 20px;
}

.save_btn button {
    background: #3085d6;
    color: #fff;
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
    border: 2px solid #3085d6;
    margin-top: 20px;
}

.houses_boxs button {
    background: #3085d6;
    color: #fff;
    padding: 10px;
    text-align: center;
    border: 2px solid #3085d6;
    margin-bottom: 15px;
}

.collection_division_pop_wrp .toggle {
    border: 0;
    background: transparent;
    box-shadow: none;
    position: absolute;
    right: 10px;
    top: 21px;
}

.collection_division_pop_wrp .toggle svg {
    width: 20px;
    height: 20px;
}

.container {
    display: block;
}

.kmlButton {
    background-color: #3085d6
}

.area-name-bg {
    box-sizing: border-box;

    /* position: absolute;
    width: 508px;
    height: 708px;
    left: 257px;
    top: 218px; */
    flex: 0 0 30%;
    background: #FFFFFF;
    border: 2px solid #E0E0E0;
    border-radius: 6px;
    /* border-left: solid #35A2FE; */
    /* background: #35A2FE; */
    /* box-shadow: 0px 0px 20px rgba(255, 239, 243, 0.03);
border-radius: 82px 0px 0px 6px; */
    /* width: 100%;
    display: flex;
    flex-wrap: wrap;
    background: #3085d6;
    padding: 10px 15px;
    padding-bottom: 0px;
    color: #fff; */
}

.area_inner_addnew_paddi {
    flex: 0 0 68%;
    background: #fff;
    padding: 10px;
}

.area-name div {
    /* width: 30%; */
    /* word-wrap: break-word; */
    padding: 0px 5px;
}

/* .details-card {
  display: flex;
  border: 1px solid #3085d6;
  margin-top: 3px;
  padding: 10px;
  margin-bottom: 15px;
  padding-bottom: 0px;
  background: #f2fbf3 !important;
  position: relative;
} */

.scroll-items {
    box-sizing: border-box;

    /*position: absolute;
    width: 1048px;
    height: 708px;
    left: 793px;
    top: 218px;*/

    background: #FFFFFF;
    border: 2px solid #E0E0E0;
    border-radius: 6px;
    /* overflow-y: auto;
    scroll-behavior: smooth;
    height: calc(100vh - 335px);
    overflow-x: hidden; */
    height: calc(100vh - 320px);
    overflow: auto;
}

.scroll-items::-webkit-scrollbar {
    width: 5px;
}

.scroll-items::-webkit-scrollbar-thumb {
    background: #888;
}

.edit {
    cursor: pointer;
    height: 20px;
    width: 53px;
    display: contents;
}

.collection_division_info {
    padding: 15px 20px;
    padding-right: 0px;
    display: flex;
    justify-content: space-around;
}

.area_inner h4 {
    font-weight: 600;
    margin-bottom: 5px;
    font-size: 14px;
    color: #79787B;
    margin-top: 5px;
}

.right {
    display: flex !important;
    justify-content: flex-end !important;
}

.action_btn {
    border: none;
    background: #fff;
    cursor: pointer;
    text-decoration: underline;
    color: red;
}


.area_inner p {
    font-size: 15px;
    font-weight: 600;
    margin: 0px;
}

.edit a {
    color: #35A2FE;
    font-weight: 600;
}

.area_inner_addnew h4 {
    font-weight: 600;
    display: flex;
    justify-content: space-between;
}

/* .area_inner_addnew {
    padding-top: 20px;
} */

.area_inner_addnew .toggle {
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
    display: inline-block;
    background: #35A2FE;
    padding: 5px 10px;
    color: #fff;
    border-radius: 5px;
    font-weight: normal;
    width: auto;
    height: auto;
}

.gradientbt {
    /* border: 2px solid #3085d6; */
    height: 35px;
}

.gradientbt:focus {
    border: 2px solid white;
    color: #35A2FE;
    background: #fff;
}

.houses_wrp {
    display: flex;
    flex-wrap: wrap;
}

.linesadded_row .flex {
    flex: 0 0 13%;
    margin-right: 10px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
}

.linesadded_row .flex .form-group {
    margin-bottom: 0;
}

.houses_label_wrp {
    display: flex;
    align-items: center;
}

.add_more_btn {
    margin-bottom: 15px;
}

.form_scrollbar {
    overflow: auto;
    height: calc(100vh - 150px);
    overflow-x: hidden;
}

.form_scrollbar::-webkit-scrollbar {
    width: 5px;
    height: 0;
}

.form_scrollbar::-webkit-scrollbar-thumb {
    background: #888;
}

.details-card h5 {
    font-weight: 600;
    margin: 0;
}

.details-card p {
    margin-bottom: 2px;
}

.collection_row .col-sm-3 {
    width: 20%;
    margin-bottom: 10px;
}

.details-card button {
    background: transparent;
    border: 0;
    color: #35A2FE;
    z-index: 2;
    position: relative;
}

.addcollecction_wrp {
    text-align: right;
    position: relative;
    bottom: 10px;
}

.area_inner_addnew_paddi {
    padding-right: 30px;
}

.edit_icons {
    position: absolute;
    right: 45px;
    flex: 0 0 5%;
}

.details-card .d-flex {
    flex: 0 0 95%;
}

.area_inner_side {
    flex: 0 0 95%;
    display: flex;
    flex-direction: column;
}

.edit_side {
    flex: 0 0 30%;
}

.edit_side button {
    box-shadow: none;
    border: 0;
    background: transparent;
    color: #35A2FE;
    padding-left: 10px;
}

.collection_divisions_table {
    margin-bottom: 20px;
}

.collection_divisions_table table {
    border-collapse: collapse;
    width: 100%;
    margin: 0;
}

.collection_divisions_table table td,
.collection_divisions_table table th {
    border: 1px solid #f4f4f4;
    text-align: left;
    padding: 8px;
}

.collection_divisions_table table td:nth-child(1),
.collection_divisions_table table th:nth-child(1) {
    max-width: 135px;
    word-wrap: break-word;
    position: relative;
    padding-right: 32px;
}

.collection_divisions_table table td:nth-child(1) button {
    position: absolute;
    right: 10px;
    top: 10px;
}

.collection_divisions_table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.collection_divisions_table tr:hover {
    background-color: #5e9cfe29 !important;
}

.view_flex {
    display: flex;
    align-items: center;
}

.noRecords {
    display: flex;
    justify-content: center;
    font-size: 16px;
}

.view-houses {
    border-radius: 0px;
    border: 1px solid transparent !important;
    background: transparent !important;
    padding: 0px;
}

.location .waste_type_pop .form-modal {
    width: 80% !important;
    height: 80% !important;
    padding: 10px 15px;
}

.area_inner_side .area_inner {
    background: transparent;
    color: black;
    padding: 10px;
    border-radius: 5px;
    margin-right: 15px;
    margin-bottom: 0px;
    flex: 1;
    max-width: 20%;

}

.area_inner {
    display: flex;
    flex: 0 0 100%;
    width: 100%;
    justify-content: space-between;
    max-width: 100% !important;
    padding: 2px 10px !important;
}

.modalbg {
    background: #fff;
    padding: 10px;
}

/* .collection_new_wrp{

}
.collection_new_wrp .area-name{
    display: flex;
    flex-direction: column;
    width: 100%;
}
.area_inner{
    display: flex;
    align-items: center;
    max-width: 100%;
} */
</style>



// WEBPACK FOOTER //
// wasteCollectionAreaDetails.vue?5e91ecd3